export const Layout = {
	contained: 'contained' as const,
	full: 'full' as const,
} as const

export type Layout = (typeof Layout)[keyof typeof Layout]

export type CrumbMeta = { label: string; clickable?: boolean }
export type StaticCrumb =
	| CrumbMeta
	| ((ctx: {
			params: Record<string, string | number>
			search: Record<string, string | number>
	  }) => CrumbMeta)
